export const USER_ROLES = {
  ROOT: 'ROLE_SUPER_ADMIN',
  ADMIN: 'ROLE_ADMIN',
  MANAGER: 'ROLE_MANAGER',
  USER: 'ROLE_USER',
};
